import { TiptapContent, TiptapContentNode, TiptapNodeType } from '../../tiptapTypes';
import { ImMap, prop, propIn } from '../../../utils/immutableHelper';
import { EditorState } from '@tiptap/pm/state';

/**
 * Returns the visible title node from a task list document, if present.
 */
const getTaskListTitleNode = (
    textContent: ImMap<TiptapContent> | TiptapContent,
): ImMap<TiptapContentNode> | TiptapContentNode | undefined => {
    const firstNode = propIn(['content', 0], textContent);

    if (prop('type', firstNode) === TiptapNodeType.taskListTitle) return firstNode;

    return undefined;
};

/**
 * Returns whether a task list document currently renders a title node.
 */
export const hasTaskListTitle = (textContent: ImMap<TiptapContent> | TiptapContent): boolean =>
    !!getTaskListTitleNode(textContent);

/**
 * Returns whether the task list editor currently has a visible title node.
 */
export const editorStateHasTaskListTitle = (editorState: EditorState) =>
    editorState.doc.firstChild?.type.name === TiptapNodeType.taskListTitle;

/**
 * Returns whether the editor's selection sits wholly within the title node.
 */
export const editorStateHasSelectionInTaskListTitle = (editorState: EditorState) => {
    const { $from, $to } = editorState.selection;

    return (
        $from.parent.type.name === TiptapNodeType.taskListTitle && $to.parent.type.name === TiptapNodeType.taskListTitle
    );
};
